import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface Column {
  key: string;
  label: string;
  render?: (value: any, row: any) => React.ReactNode;
}
interface DetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  columns: Column[];
  data: Record<string, any>[];
}
export function DetailModal({
  isOpen,
  onClose,
  title,
  subtitle,
  columns,
  data
}: DetailModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    if (isOpen) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-40">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-41" />
      <div className="relative bg-white rounded-xl shadow-2xl border border-gray-200 w-full max-w-3xl max-h-[80vh] flex flex-col mx-4" data-id="element-42">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-43">
          <div data-id="element-44">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-45">{title}</h3>
            {subtitle && <p className="text-sm text-gray-500 mt-0.5" data-id="element-46">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700" aria-label="Close modal" data-id="element-47">
            <XIcon className="w-5 h-5" data-id="element-48" />
          </button>
        </div>

        <div className="overflow-auto flex-1 px-6 py-4" data-id="element-49">
          {data.length === 0 ? <p className="text-sm text-gray-500 text-center py-8" data-id="element-50">
              No records found.
            </p> : <table className="w-full text-sm" data-id="element-51">
              <thead data-id="element-52">
                <tr className="border-b border-gray-200" data-id="element-53">
                  {columns.map(col => <th key={col.key} className="text-left py-3 px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-54">
                      {col.label}
                    </th>)}
                </tr>
              </thead>
              <tbody data-id="element-55">
                {data.map((row, rowIndex) => <tr key={rowIndex} className="border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors" data-id="element-56">
                    {columns.map(col => <td key={col.key} className="py-3 px-3 text-gray-700" data-id="element-57">
                        {col.render ? col.render(row[col.key], row) : row[col.key]}
                      </td>)}
                  </tr>)}
              </tbody>
            </table>}
        </div>

        <div className="px-6 py-3 border-t border-gray-200 flex justify-between items-center" data-id="element-58">
          <span className="text-xs text-gray-500" data-id="element-59">
            {data.length} record{data.length !== 1 ? 's' : ''}
          </span>
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors" data-id="element-60">
            Close
          </button>
        </div>
      </div>
    </div>;
}